<template>
  <div :class="['fix-header', {'no-fixed':noFixedHeader}]">
    <header>
      <img class="logo-img" src="@assets/images/logo_transparent.png" alt="logo" />
      <span class="logo-font">All</span>
      <span class="logo-font eat">Eat</span>
      <span style="flex: 1"></span>

      <span class="header-btn" @click="goHome">HOME</span>
      <span class="header-btn" @click="aboutUs">About US</span>
      <span class="header-btn" @click="goLogin" v-if="!token">
        <i class="iconfont icon-touxiang" ></i>
        Login | Register
      </span>
      <span class="header-btn" @click="goUserPage" v-else>
        <i class="iconfont icon-touxiang" style="color:#aa0bc0"></i>
        My account
      </span>
      <span class="header-btn btn-green" @click="becomePart"
        >Become Partner</span
      >
      <span class="header-btn" style="position: relative"> 
        EN  
        <i class="el-icon-arrow-down" ></i>
      </span>
    </header>
  </div>
</template>
<script>
import bus from "@/utils/bus.js"
export default {
  name: "Header",
  props: {
    noFixedHeader: {
      type: Boolean,
      default: ()=>false
    }
  },
  data() {
    return {
      token: ''
    };
  },
  mounted() {
    this.token = localStorage.getItem('token');
    bus.$on('login',()=>{
      this.token = localStorage.getItem('token');
    })
  },
  methods: {
    goHome() {
      this.$router.replace({
        path: "/",
      });
    },
    goUserPage() {
      this.$router.push({
        path: '/my'
      })
    },
    goLogin() {
      this.$router.push({
        path: '/login',
        query: {
          a: 10
        }
      })
    },
    aboutUs() {},
    becomePart() {
      window.open('https://alleatapp.net/become-partner')
    },
  },
};
</script>

<style lang="scss" scoped>
.fix-header {
  height: 93px;
}
.no-fixed {
  header {
    position: relative!important;
  }
}
header {
  padding: 0 4%;
  display: flex;
  align-items: center;
  height: 96px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  position: fixed;
  background-color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 100;
  .logo-img {
    height: 70px;
    width: 72px;
    margin-right: 20px;
  }

  .logo-font {
    font-size: 30px;
    font-weight: bold;
    color: #aa0bc0;
  }

  .eat {
    margin-left: 8px;
    color: #aa0bc0;
    color: #26d07c;
  }

  .header-btn {
    margin-left: 16px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    height: 46px;
    padding: 0 20px;
    border-radius: 5px;
    display: inline-flex;
    line-height: 40px;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-family: sans-serif;
    font-size: 14px;
    color: #222;
    cursor: pointer;
    transition: all 0.3s ease-in-out 0s;

    i {
      margin-right: 10px;
    }

    .el-icon-arrow-down {
      margin-left: 10px;
      font-weight: 700;
      color: #000;
      margin-right: 0;
    }

    &:hover {
      box-shadow: rgba(0, 0, 0, 0.3) 0px 9px 38px,
        rgba(0, 0, 0, 0.22) 0px 15px 12px;
    }
  }

  .btn-green {
    background: #09ca6a;
    color: #fff;
  }
}
</style>
